<template src='./quarterly.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormSetup from '@/components/misc/form-setup/FormSetup'

export default {
  components: {
    'form-setup': FormSetup
  },
  data () {
    return {
      formData: null,
      planActivitiesData: null,
      planActivitiesAmountsData: null,
      quarterInfo: {
        number: null,
        year: null,
        currentActivities: []
      },
      help: {
        form: Vue.$helpConfig.projectFormReporting
      },
      formStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      summaryCalculation: null,
      changesCalculation: null,
      newActivitiesCalculation: null,
      formMarkdownElements: [
        {
          editor: 'root.comment',
          element: 'root[comment]',
          name: 'comment'
        },
        {
          editor: 'root.key aspects.cost changes.reasons',
          element: 'root[key aspects][cost changes][reasons]',
          name: 'key aspects.cost changes.reasons'
        },
        {
          editor: 'root.key aspects.date changes.reasons',
          element: 'root[key aspects][date changes][reasons]',
          name: 'key aspects.date changes.reasons'
        }
      ]
    }
  },
  computed: {
    savedFormInputValues () {
      return JSON.parse(this.formData.inputJson)
    },
    planActivitiesEditor () {
      return this.$refs.setup.editor.getEditor('root.plan activities')
    },
    costChangesEditor () {
      return this.$refs.setup.editor.getEditor('root.key aspects.cost changes')
    },
    dateChangesEditor () {
      return this.$refs.setup.editor.getEditor('root.key aspects.date changes')
    },
    summaryEditor () {
      return this.$refs.setup.editor.getEditor('root.summary')
    }
  },
  methods: {
    fetchOrganization (query) {
      const queryParamName = '?filter[search]=' + query
      const url = this.autoCompleteUrl_budgetId
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    fetchLocation (query) {
      const queryParamName = '?filter[search]=' + query
      const url = this.autoCompleteUrl_location
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    formatAutocomplete (result, props) {
      return ['<li ' + props + '>',
        '<div class="wiki-title">' + result.id + '</div>',
        '<div class="wiki-snippet"><small>' + result.name + '<small></div>',
        '</li>'].join('')
    },
    setupPage () {
      if (this.$refs.setup) {
        this.$refs.setup.loading = true
      }
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId)
        .then(
          ({ data }) => {
            // this.logConsole(data)
            // this.formData = data.payload
            this.formData = this.modifyPayload(data.payload, data.additionalInformation)
            this.$refs.setup.project = data.additionalInformation
            this.$refs.setup.formName = this.formData.name
            this.setQuarterInfo(this.formData.name)
            this.$refs.setup.formStatus = this.formData.status
            this.$refs.setup.formCode = this.formData.code
            this.$refs.setup.formatRevisions(this.formData.inputJsonRevisions, 'kvartalni', !this.isAppropriationsSelected(this.formData.data, this.formData.status))
            this.$refs.setup.pif = JSON.parse(this.formData.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config

            this.planActivitiesData = JSON.parse(this.formData.data)
            this.planActivitiesAmountsData = JSON.parse(this.formData.data).Plan?.ActivityTotalAmounts
            this.initialActivityArray(data.payload)
            // console.log(this.formData)
            this.initializeEditor(this.formData)
            this.disableSummaryActivityChange()
            this.setActivityReadonly()
            this.setDateReadonly()
            this.$refs.setup.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    onlyUnique (value, index, array) {
      return array.indexOf(value) === index
    },
    setQuarterInfo (name) {
      const parts = name.split('-')
      this.quarterInfo.year = parts[1].trim()
      this.quarterInfo.number = parts[2].trim()
    },
    changeRevision (selectedRevision) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId + '/revision/' + selectedRevision)
        .then(
          response => {
            // this.logConsole(response)
            const revision = response.data.payload
            this.$refs.setup.pif = JSON.parse(revision.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.$refs.setup.initialVal = {
              ...JSON.parse(revision.inputJson)
            }
            this.initializeEditor()
            history.pushState({}, null, ('/projects/' + this.$refs.setup.projectCode + '/phases/' + Number(this.$refs.setup.projectPhaseId) + '/forms/kvartalni/id/' + Number(this.$refs.setup.phaseFormId) + '/revision/' + this.$refs.setup.revision.revision))
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    isAppropriationsSelected (data, status) {
      if (status === this.formStatus.LOCKED || status === this.formStatus.APPROVED) {
        if (data) {
          let parsedData = JSON.parse(data)
          if (parsedData.SuccessKeyIndicator) {
            parsedData = parsedData.SuccessKeyIndicator
          }
          return parsedData.FundingAdequacyIndicator ? parsedData.FundingAdequacyIndicator.AppropriationAmount ? parsedData.FundingAdequacyIndicator.AppropriationAmount > 0 : false : false
        }
        return false
      }
      return true
    },
    setActivitiesValues () {
      const savedCostActivitiesArray = this.$refs.setup.initialVal['key aspects']['cost changes'].activities || []
      const savedDateActivitiesArray = this.$refs.setup.initialVal['key aspects']['date changes'].activities || []
      const savedSummaryActivitiesArray = this.$refs.setup.initialVal.summary.activities || []
      const costActivitiesArray = []
      const dateActivitiesArray = []
      const summaryActivitiesArray = []
      const allActivities = ['']

      // set all activities from plan form
      this.planActivitiesData.Plan.ActivityTotalAmounts.forEach(planActivity => {
        const duplicateCostActivity = savedCostActivitiesArray.find(savedActivity => savedActivity.name === planActivity.Name)
        const duplicateDateActivity = savedDateActivitiesArray.find(savedActivity => savedActivity.name === planActivity.Name)
        const newEstimate = duplicateCostActivity ? Number(duplicateCostActivity['new estimate']?.toString().replaceAll('.', '').replaceAll(',', '.')) : Number(planActivity.Amount.toString().replaceAll(',', '.'))

        costActivitiesArray.push(
          {
            name: planActivity.Name,
            'new estimate': this.formatAmount(newEstimate),
            'old estimate': this.formatAmount(planActivity.InitialAmount)
          }
        )

        dateActivitiesArray.push(
          {
            name: planActivity.Name,
            'new date': duplicateDateActivity ? duplicateDateActivity['new date'] : planActivity.Date,
            'old date': duplicateDateActivity ? duplicateDateActivity['old date'] : this.planActivitiesData.Plan.ImplementationDates.end
          }
        )

        allActivities.push(planActivity.Name)
      })

      // set all activities that are not part of the plan form but were entered afterwards
      savedCostActivitiesArray.forEach(savedActivity => {
        const index = costActivitiesArray.findIndex(planActivity => planActivity.name === savedActivity.name)
        if (index === -1) {
          costActivitiesArray.push({
            name: savedActivity.name || '',
            'new estimate': savedActivity['new estimate'] || this.formatAmount(0),
            'old estimate': ''
          })

          allActivities.push(savedActivity.name)
        }
      })

      savedDateActivitiesArray.forEach(savedActivity => {
        const index = dateActivitiesArray.findIndex(planActivity => planActivity.name === savedActivity.name)
        if (index === -1) {
          dateActivitiesArray.push({
            name: savedActivity.name || '',
            'new date': savedActivity['new date'],
            'old date': ''
          })

          allActivities.push(savedActivity.name)
        }
      })

      const summeryActivityModel = this.summaryEditor.editors.activities.getValue()[0]
      // console.log(summeryActivityModel)
      this.planActivitiesData.Activities.forEach(activity => {
        if (activity.Amount) {
          this.quarterInfo.currentActivities.push(activity.Name)
        }
      })
      this.quarterInfo.currentActivities.forEach(planActivity => {
        const index = savedSummaryActivitiesArray.findIndex(savedActivity => savedActivity.name === planActivity)
        if (index === -1) {
          summaryActivitiesArray.push({
            ...summeryActivityModel,
            name: planActivity
          })
        }
      })

      const summaryActivitiesArrayInitVal = [
        ...summaryActivitiesArray,
        ...savedSummaryActivitiesArray
      ]

      // console.log(savedSummaryActivitiesArray)
      // console.log(summaryActivitiesArrayInitVal)

      this.$refs.setup.initialVal['key aspects']['cost changes'].activities = costActivitiesArray
      this.$refs.setup.initialVal['key aspects']['date changes'].activities = dateActivitiesArray
      this.$refs.setup.initialVal.summary.activities = summaryActivitiesArrayInitVal
      this.$refs.setup.initialVal['plan activities'] = allActivities.filter(this.onlyUnique)
    },
    onActivitiesChange (type) {
      const changedEditor = type === 'COST' ? this.costChangesEditor : this.dateChangesEditor
      const toChangeEditor = type === 'COST' ? this.dateChangesEditor : this.costChangesEditor
      const summaryActivities = this.summaryEditor
      let changeType = ''
      let changedActivity = ''
      const allActivities = ['']
      const cleanedAllActivities = [
        ...this.planActivitiesEditor.getValue()
      ]

      if (cleanedAllActivities[0] === '') {
        cleanedAllActivities.shift()
      }

      this.costChangesEditor.editors.activities.rows.forEach(changedAcitivityRow => {
        allActivities.push(changedAcitivityRow.getValue().name)
      })

      this.dateChangesEditor.editors.activities.rows.forEach(dateActivityRow => {
        allActivities.push(dateActivityRow.getValue().name)
      })

      if (changedEditor.editors.change.getValue() === 'Да') {
        // console.log(changedEditor.editors.activities.rows.length)
        // console.log(cleanedAllActivities.length)
        if (changedEditor.editors.activities.rows.length < cleanedAllActivities.length) {
          changeType = 'DELETED'

          cleanedAllActivities.forEach(activity => {
            const index = changedEditor.editors.activities.rows.findIndex(changedAcitivityRow => changedAcitivityRow.getValue().name === activity)
            if (index === -1) {
              changedActivity = activity
            }
          })
        }

        if (changedEditor.editors.activities.rows.length > cleanedAllActivities.length) {
          changeType = 'ADDED'

          changedEditor.editors.activities.rows.forEach(changedAcitivityRow => {
            const index = cleanedAllActivities.findIndex(activity => activity === changedAcitivityRow.getValue().name)
            if (index === -1) {
              changedActivity = changedAcitivityRow.getValue().name
            }
          })

          if (changedEditor.editors.change.getValue() === 'Да' && toChangeEditor.editors.change.getValue() === 'Не') {
            toChangeEditor.editors.change.setValue('Да')
          }
        }
      }

      this.planActivitiesEditor.setValue(allActivities.filter(this.onlyUnique))

      if (changeType === 'ADDED' && changedActivity) {
        const newElement = type === 'DATE' ? {
          name: changedActivity,
          'new estimate': this.formatAmount(0),
          'old estimate': ''
        } : {
          name: changedActivity,
          'new date': this.planActivitiesData.Plan.ImplementationDates.end,
          'old date': ''
        }
        const newSummaryElement = {
          name: changedActivity,
          details: {
            physical: {
              'activity fulfilled': 'Да'
            },
            financial: {
              'real expense': '',
              'target reason': '',
              'target percent': 0,
              'planned expense': '0,00',
              'target measures': ''
            }
          }
        }
        const toChangeEditorVal = [
          ...toChangeEditor.editors.activities.getValue(),
          newElement
        ]
        toChangeEditor.editors.activities.setValue(toChangeEditorVal)

        const toChangeSummaryVal = [
          ...summaryActivities.editors.activities.getValue(),
          newSummaryElement
        ]
        summaryActivities.editors.activities.setValue(toChangeSummaryVal)
      }
      if (changeType === 'DELETED' && changedActivity) {
        toChangeEditor.editors.activities.setValue(toChangeEditor.editors.activities.getValue().filter(activity => activity.name !== changedActivity))
        this.summaryEditor.editors.activities.setValue(this.summaryEditor.editors.activities.getValue().filter(activity => activity.name !== changedActivity))
      }

      this.disableSummaryActivityChange()
    },
    disablePlanActivitiesInputs () {
      this.planActivitiesData.Plan.ActivityTotalAmounts.forEach(planActivity => {
        this.costChangesEditor.editors.activities.rows.forEach(costActivityRow => {
          if (planActivity.Name === costActivityRow.getValue().name) {
            costActivityRow.editors.name.disable()
            costActivityRow.delete_button && costActivityRow.delete_button.classList.add('disabled')
          }
        })
        this.dateChangesEditor.editors.activities.rows.forEach(dateActivityRow => {
          if (planActivity.Name === dateActivityRow.getValue().name) {
            dateActivityRow.editors.name.disable()
            dateActivityRow.delete_button && dateActivityRow.delete_button.classList.add('disabled')
          }
        })
      })
      this.quarterInfo.currentActivities.forEach(planActivity => {
        this.summaryEditor.editors.activities.rows.forEach(summaryActivityRow => {
          if (planActivity === summaryActivityRow.getValue().name) {
            summaryActivityRow.editors.name.disable()
            if (summaryActivityRow.delete_button !== undefined) { summaryActivityRow.delete_button.classList.add('disabled') }
          }
        })
      })
    },
    initializeEditor () {
      this.$refs.setup.configureEditor()
      this.$refs.setup.editor.getEditor('root.summary.activities').add_row_button.classList.add('disabled')
      this.$refs.setup.editor.on('ready', () => {
        // this.initialMarkdownControls()

        this.$refs.setup.initialVal = {
          ...this.$refs.setup.editor.getValue(),
          ...this.savedFormInputValues
        }

        this.setActivitiesValues()

        if (this.$refs.setup.initialVal) {
          this.$refs.setup.saveJsonValues(this.$refs.setup.initialVal)
        }

        this.$refs.setup.manageInput()
        this.disablePlanActivitiesInputs()
        this.$refs.setup.editor.watch('root.key aspects.cost changes.activities', () => this.onActivitiesChange('COST'))
        this.$refs.setup.editor.watch('root.key aspects.date changes.activities', () => this.onActivitiesChange('DATE'))
        this.roundNumberValues()
        // console.log(this.$refs.setup.editor)
      })

      this.$refs.setup.editor.on('change', () => {
        const values = this.$refs.setup.editor.getValue()
        const val = this.$refs.setup.initialVal
        this.$refs.setup.formChanged = !this.deepEqual(val, values)

        this.setPlannedExpense(values)
        const costChangesTotal = this.$refs.setup.editor.getEditor('root.key aspects.cost changes.totals')
        costChangesTotal.header.innerHTML = this.formatCostChangesTotalCalculation(values)
        const summaryTotal = this.$refs.setup.editor.getEditor('root.summary.totals')
        summaryTotal.header.innerHTML = this.formatSummaryTotalCalculation(values)
        this.setActivityReadonly()
        this.setDateReadonly()
        this.roundNumberValues()
        // console.log(this.$refs.setup.editor.getEditor('root.key aspects.date changes.activities'))
      })
    },
    initialActivityArray (payload) {
      const schema = this.$refs.setup.pif.schema
      if (payload.data !== undefined) {
        // this.logConsole('initialActivityArray')
        // this.logConsole(payload)
        const data = JSON.parse(payload.data)
        schema.properties.summary.properties.activities.minItems = data.Activities.length
        schema.properties['key aspects'].properties['cost changes'].properties.activities.minItems = data.Activities.length
        schema.properties['key aspects'].properties['date changes'].properties.activities.minItems = data.Activities.length
      }
    },
    disableSummaryActivityChange () {
      this.summaryEditor.editors.activities.rows.forEach(summaryActivityRow => {
        summaryActivityRow.editors.name.disable()
        if (summaryActivityRow.delete_button !== undefined) { summaryActivityRow.delete_button.classList.add('disabled') }
      })
    },
    modifyPayload (payload, additionalInformation) {
      const inputJson = JSON.parse(payload.inputJson)
      if (inputJson['proposer info'] !== undefined) {
        if (inputJson['proposer info']['authorized organization']['authorized proposer'] === undefined || inputJson['proposer info']['authorized organization']['authorized proposer'] === '') {
          inputJson['proposer info']['authorized organization']['authorized proposer'] = additionalInformation.organizationName
        }
      }
      var summary = ''
      var activities = []
      if (inputJson.summary === undefined && inputJson['financial info'] !== undefined) {
        const activityList = inputJson['financial info'].activityList
        if (activityList !== undefined) {
          activityList.forEach((activity) => {
            summary = '{"name":"' + activity.name + '","details":{"physical":{"activity fulfilled":"Да"},"financial":{"real expense":"","target reason":"","target percent":0,"planned expense":"0,00","target measures":""}}}'
            activities.push(JSON.parse(summary))
          })
        }
        inputJson.summary = JSON.parse('{"activities": ' + JSON.stringify(activities) + '}')
      } else if (inputJson.summary !== undefined) {
        const data = JSON.parse(payload.data)
        // console.log(inputJson)''
        const summaryActivities = inputJson.summary.activities
        data.Activities.forEach((dataActivity) => {
          summary = (summaryActivities.find(x => x.name === dataActivity.Name) !== undefined) ? JSON.stringify(summaryActivities.find(x => x.name === dataActivity.Name)) : '{"name":"' + dataActivity.Name + '","details":{"physical":{"activity fulfilled":"Да"},"financial":{"real expense":"","target reason":"","target percent":0,"planned expense":"0,00","target measures":""}}}'
          activities.push(JSON.parse(summary))
        })
        summaryActivities.forEach((summaryActivity) => {
          summary = (data.Activities.find(x => x.Name === summaryActivity.name) === undefined) ? JSON.stringify(summaryActivity) : ''
          if (summary !== '') activities.push(JSON.parse(summary))
        })

        inputJson.summary = JSON.parse('{"activities": ' + JSON.stringify(activities) + '}')
      }

      payload.inputJson = JSON.stringify(inputJson)
      // this.logConsole('Modified data')
      // this.logConsole(payload)
      return payload
    },
    setPlannedExpense (values) {
      const activities = this.$refs.setup.editor.getEditor('root.summary.activities')
      for (var j = 0; j < activities.rows.length; j++) {
        let val = 0
        const plannedExpenseControl = activities.rows[j].editors.details.editors.financial.editors['planned expense']
        if (activities.rows[j].editors.name.value) {
          const actAmount = this.planActivitiesData.Activities.filter(x => x.Name === activities.rows[j].editors.name.value)[0]
          if (actAmount) {
            val = actAmount.Amount || 0
          }
        } else {
          val = 0
        }
        plannedExpenseControl.setValue(this.formatAmount(val))
        values.summary.activities[j].details.financial['planned expense'] = this.formatAmount(val)
        const realExpenseControl = activities.rows[j].editors.details.editors.financial.editors['real expense']
        const targetPercentControl = activities.rows[j].editors.details.editors.financial.editors['target percent']
        const targetReasonEl = document.querySelector(`[data-schemapath="root.summary.activities.${j}.details.financial.target reason"]`)
        const targetMeasuresEl = document.querySelector(`[data-schemapath="root.summary.activities.${j}.details.financial.target measures"]`)
        var realExpense = Number(realExpenseControl.input.value.toString().replaceAll('.', '').replaceAll(',', '.'))
        var planExpense = Number(plannedExpenseControl.input.value.toString().replaceAll('.', '').replaceAll(',', '.'))
        if (realExpense === 0 && planExpense === 0) {
          values.summary.activities[j].details.financial['target percent'] = 100
          targetPercentControl.setValue(this.formatAmount(100))
          targetReasonEl.style.display = 'none'
          targetMeasuresEl.style.display = 'none'
        } else if (planExpense === 0) {
          values.summary.activities[j].details.financial['target percent'] = 0
          targetPercentControl.setValue('∞')
          if (realExpense !== 0) {
            targetReasonEl.style.display = 'block'
            targetMeasuresEl.style.display = 'block'
          }
        } else {
          values.summary.activities[j].details.financial['target percent'] = realExpense / planExpense * 100
          const formatedAmount = this.formatAmount(realExpense / planExpense * 100)
          targetPercentControl.setValue(formatedAmount)
          targetReasonEl.style.display = formatedAmount === '100,00' ? 'none' : 'block'
          targetMeasuresEl.style.display = formatedAmount === '100,00' ? 'none' : 'block'
        }
      }
    },
    // initialMarkdownControls () {
    //   for (var j = 0; j < this.$refs.setup.markdownElements.length; j++) {
    //     this.$refs.setup.configureMarkdownElement(this.$refs.setup.markdownElements[j])
    //     if (this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor)) {
    //       this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor).simplemde_instance.codemirror.on('change', () => {
    //         this.checkChanges()
    //       })
    //     }
    //   }
    // },
    formatCostChangesTotalCalculation (values) {
      this.getCostChangesCalculation(values)
      if (this.costChangesCalculation !== null) {
        return `<label style="font-size: 15px; font-weight: 600;">Укупно из плана реализације: ${this.formatAmount(this.costChangesCalculation.totalPlanAmount !== null ? this.costChangesCalculation.totalPlanAmount : 0)} </label>
        <br><label style="font-size: 15px; font-weight: 600;">Укупно са новим проценама: ${this.formatAmount(this.costChangesCalculation.totalNewAmount !== null ? this.costChangesCalculation.totalNewAmount : 0)} </label>`
      }
      return ''
    },
    // formatNewActivitiesTotalCalculation (values) {
    //   this.getNewActivitiesCalculation(values)
    //   if (this.newActivitiesCalculation !== null) {
    //     return '<label style="font-size: 15px; font-weight: 600;">Укупно: ' + this.formatAmount(this.newActivitiesCalculation.totalAmount) + '</label>'
    //   }
    //   return ''
    // },
    formatSummaryTotalCalculation (values) {
      this.getSummaryCalculation(values)
      // console.log(this.summaryCalculation)
      return `Укупно trt:
              <table style="width:100%">
                <thead style="text-align:right">
                  <tr>
                    <th>Планирани расходи</th>
                    <th>Остварени расходи</th>
                    <th>Проценат реализације плана</th>
                  </tr>
                  <tr><td><hr></td><td><hr></td><td><hr></td><td><hr></td></tr>
                </thead>
                <tbody style="text-align:right">
                  <tr>
                    <td>` + this.formatAmount(this.summaryCalculation !== null ? this.summaryCalculation.plannedAmount : 0, 0) + `</td>
                    <td>` + this.formatAmount(this.summaryCalculation !== null ? this.summaryCalculation.realizedAmount : 0, 0) + `</td>
                    <td>` + this.formatAmount(this.summaryCalculation !== null ? this.summaryCalculation.percentage : 0) + `</td>
                  </tr>
                </tbody>
              </table>`
    },
    getCostChangesCalculation (values) {
      this.costChangesCalculation = null
      const totalPlanAmount = this.sumReal(this.planActivitiesAmountsData.map(activity => activity.InitialAmount))

      const costChangesActivities = values['key aspects']['cost changes'].activities
      let totalNewAmount = null
      if (costChangesActivities) {
        totalNewAmount = this.sum(costChangesActivities.map(activity => {
          return activity['new estimate']
        }))
      }

      this.costChangesCalculation = {
        totalPlanAmount: totalPlanAmount,
        totalNewAmount: totalNewAmount
      }
    },
    // getNewActivitiesCalculation (values) {
    //   this.newActivitiesCalculation = null

    //   const newActivities = values['key aspects']['new activities'].activities
    //   if (newActivities) {
    //     let totalAmount = this.sum(newActivities.map(item => item.expense))
    //     totalAmount = totalAmount === '' ? 0 : parseFloat(totalAmount)
    //     this.newActivitiesCalculation = {
    //       newActivities: newActivities,
    //       totalAmount: totalAmount
    //     }
    //   }
    // },
    getSummaryCalculation (values) {
      this.summaryCalculation = null
      // var newActivitiesAmount = 0
      // if (this.newActivitiesCalculation !== null) {
      //   newActivitiesAmount = this.newActivitiesCalculation.totalAmount
      // }
      const summary = values.summary.activities
      if (summary) {
        let plannedExpenseAmount = this.sum(summary.map(item => item.details.financial['planned expense']))
        let realizedExpenseAmount = this.sum(summary.map(item => item.details.financial['real expense']))
        plannedExpenseAmount = plannedExpenseAmount === '' ? 0 : parseFloat(plannedExpenseAmount)
        realizedExpenseAmount = realizedExpenseAmount === '' ? 0 : parseFloat(realizedExpenseAmount)
        this.summaryCalculation = {
          plannedAmount: plannedExpenseAmount,
          realizedAmount: realizedExpenseAmount,
          percentage: (plannedExpenseAmount === 0 && realizedExpenseAmount === 0) ? 100 : (plannedExpenseAmount === 0) ? 0 : realizedExpenseAmount / plannedExpenseAmount * 100
        }
      }
    },
    setActivityVisibility () {
      // console.log(this.costChangesEditor)
      const activityEditor = this.costChangesEditor
      const dataEditor = this.dateChangesEditor
      if (activityEditor.editors.change.getValue() === 'Не') {
        activityEditor.editors.activities.options.hidden = true
      } else {
        activityEditor.editors.activities.options.hidden = false
      }
      if (dataEditor.editors.change.getValue() === 'Не') {
        dataEditor.editors.activities.options.hidden = true
      } else {
        dataEditor.editors.activities.options.hidden = false
      }
    },
    setActivityReadonly () {
      const activityEditor = this.costChangesEditor
      if (activityEditor.editors.change.getValue() === 'Не') {
        const activities = activityEditor.editors.activities.rows
        for (var j = 0; j < activities.length; j++) {
          activities[j].editors['new estimate'].disable()
          // activities[j].editors['new estimate'].setValue(activities[j].editors['old estimate'].getValue())
        }
      } else {
        const activities = activityEditor.editors.activities.rows
        for (var x = 0; x < activities.length; x++) {
          activities[x].editors['new estimate'].enable()
        }
      }
    },
    setDateReadonly () {
      const dateEditor = this.dateChangesEditor
      if (dateEditor.editors.change.getValue() === 'Не') {
        const activities = dateEditor.editors.activities.rows
        for (var j = 0; j < activities.length; j++) {
          // var d = activities[j].editors['old date'].getValue()
          // activities[j].editors['new date'].setValue(d.substring(0, 10))
          activities[j].editors['new date'].disable()
        }
      } else {
        const activities = dateEditor.editors.activities.rows
        for (var x = 0; x < activities.length; x++) {
          activities[x].editors['new date'].enable()
        }
      }
    },
    roundNumberValues () {
      const editors = this.$refs.setup.editor.editors
      for (const key in editors) {
        if (editors[key].format === 'integer') {
          editors[key].setValue(this.formatAmount(this.formatNumber(editors[key].getValue()), 0))
        }
      }
    }
  },
  created () {
    this.setupPage()
    EventBus.$on('setupPage', () => {
      if (this.$refs && this.$refs.setup) {
        this.$refs.setup.revision = {
          revision: null
        }
      }
      this.setupPage()
    })
    EventBus.$on('changeRevision', (revision) => {
      this.changeRevision(revision)
    })
  },
  beforeDestroy () {
    EventBus.$off('setupPage')
    EventBus.$off('changeRevision')
  }
}
</script>
